/* global bocAmchart4, am4core */
/**
 * Draws an arrow and/or line on chart
 *
 * @param {Object} chart - The chart object
 * @param {number} startX - starting x-coordinate of arrow
 * @param {number} startY - starting y-coordinate of arrow
 * @param {number} endX - ending x-coordinate of arrow
 * @param {number} endY - ending y-coordinate of arrow
 * @param {string} lineType - Type of line: solid, dashed, dotted
 * @param {(string|number)} lineColor - Color of arrow
 * @param {boolean} hasArrowHead - option for omitting arrow-head (line only)
 * @returns {object} - Reference to series/line
 */
bocAmchart4.addArrow = function (chart, startX, startY, endX, endY, lineType, lineColor, hasArrowHead) {
    // Calculate the angle between the two points
    let angle = (90 - bocAmchart4.calculateAngleDegrees(startX, startY, endX, endY)) % 360;

    // Create a line series
    let lineSeries = chart.series.push(new am4charts.LineSeries());
    lineSeries.name = "arrow";

    // Add data points for the line series
    lineSeries.data = [
        {x: startX, y: startY, bulletVisible: true},
        {x: endX, y: endY, bulletVisible: !hasArrowHead}
    ];

    // Validate color input
    let color;
    if (typeof lineColor === 'number' && lineColor >= 0 && lineColor <= bocAmchart4.bocColors.length) {
        color = bocAmchart4.bocColors[lineColor];
    } else if (typeof lineColor === 'string') {
        color = lineColor;
    } else {
        //default color
        color = "#000";
    }

    // Configure the line series
    lineSeries.dataFields.valueX = "x";
    lineSeries.dataFields.valueY = "y";
    lineSeries.stroke = am4core.color(color);
    lineSeries.events.once("inited", function () {
        lineSeries.parent.zIndex = 10;
    });

    // Set line type
    switch (lineType) {
        case "solid":
            lineSeries.strokeDasharray = "";
            break;
        case "dashed":
            lineSeries.strokeDasharray = "4,4";
            break;
        case "dotted":
            lineSeries.strokeDasharray = "1,1";
            break;
        default:
            lineSeries.strokeDasharray = lineType;
    }

    // Add a bullet (triangle arrow) at the end of the line series
    let arrowBullet = lineSeries.bullets.push(new am4charts.Bullet());
    arrowBullet.propertyFields.disabled = "bulletVisible";

    let triangle = arrowBullet.createChild(am4core.Triangle);
    triangle.horizontalCenter = "middle";
    triangle.verticalCenter = "bottom";

    triangle.width = 10;
    triangle.height = 12;
    triangle.fill = am4core.color(color);
    arrowBullet.rotation = angle;

    lineSeries.hiddenInLegend = true;
    lineSeries.arrowBullet = arrowBullet;


    //this function will recalculate the arrow head rotation but based on the
    //point system of the chart
    let updateArrowRotation = () => {
        // Get the pixel positions of the start and end data points
        let lineStartPoint = lineSeries.dataItems.getIndex(0);
        let lineEndPoint = lineSeries.dataItems.getIndex(1);

        // some edge case checking
        if (!lineStartPoint || !lineEndPoint) {
            return;
        }
        if (!lineStartPoint.point || !lineEndPoint.point) {
            return;
        }

        // get the new line points but in terms of the chart coordinate system
        let startPoint = lineStartPoint.point;
        let endPoint = lineEndPoint.point;
        let dx = endPoint.x - startPoint.x;
        let dy = endPoint.y - startPoint.y;

        // Compute new angle to set the arrow head to when the line changes
        let screenAngle = Math.atan2(dy, dx) * (180 / Math.PI);

        //change the rotation
        arrowBullet.rotation = screenAngle + 90;
    };
    // Update arrow rotation whenever the chart is updated
    chart.events.on("zoomended", updateArrowRotation);
    arrowBullet.events.on("positionchanged", updateArrowRotation);
    return lineSeries;
};

/**
 * Helper function that calculates angle for arrow head
 *
 * @param {number} x1 - starting x-coordinate of arrow
 * @param {number} y1 - starting y-coordinate of arrow
 * @param {number} x2 - ending x-coordinate of arrow
 * @param {number} y2 - ending y-coordinate of arrow
 * @returns {number} The calculated arrowHead angle
 */
bocAmchart4.calculateAngleDegrees = function (x1, y1, x2, y2) {
    let angleRad = Math.atan2(y2 - y1, x2 - x1);
    let angleDeg = angleRad * (180 / Math.PI);

    if (angleDeg < 0) {
        angleDeg += 360;
    }

    return angleDeg;
};

/**
 * Adds a label(s) to chart
 *
 * @param {Object} chart - The chart object
 * @param {Object[]} labels - An array of objects containing label properties
 * @param {number} labels.x - x-coordinate of label
 * @param {number} labels.y - y-coordinate of label
 * @param {string} labels.textAlignment - text alignment
 * @param {string} labels.text - label text
 * @returns {void}
 */
bocAmchart4.addLabels = function (chart, labels) {
    let newSeries = chart.series.push(new am4charts.XYSeries());
    newSeries.name = "chartLabels";
    newSeries.dataFields.valueX = "x";
    newSeries.dataFields.valueY = "y";
    newSeries.hiddenInLegend = true;

    newSeries.data = labels.map(label => ({
        labelText: label.text,
        labelTextAlignment: label.textAlignment,
        x: label.x,
        y: label.y
    }));

    // wait for chart to be initialized, then add labels
    newSeries.events.on("inited", () => {
        let bullet = newSeries.bullets.push(new am4charts.LabelBullet());
        newSeries.dataItems.each(() => {
            bullet.label.text = "{labelText}";

            bullet.label.adapter.add("textAlign", function (textAlign, target) {
                return target.dataItem.dataContext.labelTextAlignment || "middle";
            });

            bullet.label.verticalCenter = "bottom";
            bullet.label.horizontalCenter = "middle";
            bullet.label.wrap = true;
            bullet.label.truncate = false;
            bullet.label.fontSize = 13;
            bullet.label.maxHeight = 400;
        });
    });
};
